<template>
  <div class="charts" :style="chartstyle">
    <h4 v-if="title" :style="titlestyle">{{title}}</h4>
    <line-chart v-if="chartLoaded" :chartData="datacollection" :options="chartOptions"></line-chart>
  </div>
</template>

<script>

  /*

   Hourly Chart               23-Oct-19      wjscott     (wip)

   Accepts a simple array of values to chart and makes the creation of an hourly sales, or hourly activity, chart
   easy without having to do all the system of the chart control.

   Most props have defaults so basically chartData is the only "real" requirement for a quck chart.  Multiple datasets
   yield a stacked bar chart. Keep in mind that the smaller this chart becomes and the more datasets the more
   awkward this control will render.

   Chart details can be found here: https://www.chartjs.org/docs/latest/charts/bar.html


   "Base Chart" Dependencies:

    - LineChart.vue



   Revision History
   ----------------

   */

  import LineChart from "./basecharts/LineChart.vue";

  export default {
    components: {
      LineChart
    },                // caution with too many prop cuz at some point it's like having the chart under direct control -- this is supposed to be a "simple" way to make a chart
    props     : {
      charttype : {type: String, default: "bar"},         // this control can do bar or line.
      chartstyle: {type: String, default: ""},            // style the overall surounding div
      filltype  : {type: String, default: "none"},        // as defined by the type of chart
      chartData : {type: Array, default: () => []},       // our chart data
      title     : {type: String, default: ""},            // chart title
      titlestyle: {type: String, default: ""},            // style the above title
      labelStyle: {type: Number, default: 0},             // 0 - full labels, 1 = short, 2 = use labels passed in
      labels    : {type: Array, default: () => []},       // replacement bottom row labels
      baseformat: {type: Object, default: () => {}}       // replaces the 'bardata' if passed
    },
    calculated: {
      chartstyle() {
        return this.chartstyle;
      },
      titlestyle() {
        return this.titlestyle;
      }
    },
    data() {
      let expandedLabels = [ 'Midnight to 1am', '1am to 2am', '2am to 3am', '3am to 4am', '4am to 5am', '5am to 6am',
                             '6am to 7am', '7am to 8am', '8am to 9am', '9am to 10am', '10am to 11am', '11am to Noon',
                             'Noon to 1pm', '1pm to 2pm', '2pm to 3pm', '3pm to 4pm', '4pm to 5pm', '5pm to 6pm',
                             '6pm to 7pm', '7pm to 8pm', '8pm to 9pm', '9pm to 10pm', '10pm to 11pm', '11pm to Midnight' ];

      let shortLabels = [ 'M', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11',
                          'N', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11' ];

      return {
        datacollection: null,
        chartOptions  : null,
        chartLoaded   : false,
        chartLabels   : [ expandedLabels, shortLabels, this.labels ]
      }
    },
    created() {
      this.init()
    },
    methods   : {
      init() {

        // console.log("init() array", JSON.stringify(this.chartdata, null, 2));

        let bardata = {       // default bar data set
          type                : this.charttype,
          backgroundColor     : 'rgba(55,200,0,.5)',    // default to something...
          borderColor         : 'rgba(55,200,0,.5)',
          borderSkipped       : 'true',        // default
          borderWidth         : 1,
          hoverBackgroundColor: "rgba(55,200,0,.8)", // 'rgba(0,200,0,.9)',
          fill                : this.filltype,   // none,top, bottom
          label               : '',
          data                : null
        }

        this.datacollection = {
          labels  : this.chartLabels[ this.labelStyle ],
          datasets: []
        };

        this.chartOptions = {
          responsive          : true,
          maintainAspectRation: false,
          scales              : {
            xAxes: [ {
              stacked: true
            } ],
            yAxes: [ {
              stacked: true
            } ]
          }
        };

        this.chartData.forEach((d) => {
          if(this.baseformat) {
            this.datacollection.datasets.push({...this.baseformat, ...d});
          } else {
            this.datacollection.datasets.push({...bardata, ...d});
          }
        });

        this.chartLoaded = true;
      }
    }
  }
</script>
<style>
  .charts {
    text-align   : center;
    margin-left  : auto;
    margin-right : auto;
  }
</style>
